/**
 * Builds diagnostic info for empty AI responses.
 * Used by both SideChat and AssistantChat to log + track the error.
 */
export function buildEmptyResponseDiagnostics(
  messages: { id: string; role: string; parts?: Record<string, unknown>[] }[],
  newAssistantMsgs: { id: string; role: string; parts?: Record<string, unknown>[] }[],
  allParts: Record<string, unknown>[],
  lastAssistantMsg: { id: string }
) {
  const lastMsgParts =
    (newAssistantMsgs[newAssistantMsgs.length - 1] as { parts?: Record<string, unknown>[] })
      ?.parts || []
  const lastPartTypes = lastMsgParts.map(p => String(p.type ?? 'unknown')).join(',') || '(none)'
  const allPartTypes =
    [...new Set(allParts.map(p => String(p.type ?? 'unknown')))].join(',') || '(none)'

  return {
    totalMessageCount: messages.length,
    newAssistantMessageCount: newAssistantMsgs.length,
    lastPartTypes,
    allPartTypes,
    lastMsgId: lastAssistantMsg.id,
  }
}
